import {Component, Input, OnInit} from "@angular/core";
import {TimeService} from "../../../services/time.service";
import {Project} from "../../../services/model/projects.model";
import {isNullOrUndefined} from "util";

@Component({
    selector: 'app-islate',
    templateUrl: './is-late.component.html',
})
export class IsLateComponent implements OnInit{

    @Input('project') project: Project;
    constructor(
        public timeServ: TimeService
    ){}

    ngOnInit(){
    }

    isNone(date) {
        return isNullOrUndefined(date);
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/is-late/is-late.component.ts